import { useEffect, useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import { formatDateTime, getDateRange } from "../../../../../utils/DateUtils";
import Api from "../../../../../constants/Api";
import { ApiError } from "../../../../components/Common/ApiError";
import LoadingCenter from "../../../../components/Common/LoadingCenter";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { convertDoubleToStringPTBR } from "../../../../../utils/ConverterUtils";

const CommissionHistory = (props) => {

    const { t } = useTranslation();
    const { entityId, month, year } = props;
    const [showLoading, setShowLoading] = useState(true);
    const [history, setHistory] = useState([]);
    const [subscriptionHistory, setSubscriptionHistory] = useState([]);
    const [totalHistory, setTotalHistory] = useState(0.0);

    useEffect(() => {
        setShowLoading(true);
        const dateRange = getDateRange(month, year);
        axiosInstance.get(`${Api.sales.visual_report}/commission/${entityId}/${dateRange.start}/${dateRange.end}/history`)
            .then((resp) => {
                setHistory(resp.data.history);
                setSubscriptionHistory(resp.data.subscriptionHistory);
                setTotalHistory(resp.data.totalHistory);
            })
            .catch(error => ApiError(error))
            .finally(() => setShowLoading(false));
    }, [entityId, month, year]);

    return (
        <div className="commission-history-modal__content">
            {
                (showLoading) ?
                    <LoadingCenter className={"mt-5"} />
                    :
                    <>
                        <h3>{t('gamification.pot_ordinary_commission')}</h3>
                        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                            <Table responsive striped>
                                <thead>
                                    <tr>
                                        <th>{t('date_time')}</th>
                                        <th>{t('product')}</th>
                                        <th>{t('total')}</th>
                                        <th>{t('gamification.pot_ordinary_commission')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((item, index) => (
                                        <tr key={index}>
                                            <td>{formatDateTime(item.createdAt)}</td>
                                            <td>{item.qty} x {item.product.name}</td>
                                            <td>
                                                {t('currency_symbol')} {convertDoubleToStringPTBR(item.total)}
                                                {/* Com cupom no pedido, o percentual incide sobre a parte que
                                                    coube a este item, não sobre o valor cheio. Sem mostrar a
                                                    base, a linha não fecha na conta de quem confere na mão. */}
                                                {item.commissionBase != null && item.commissionBase !== item.total && (
                                                    <small className="d-block text-muted">
                                                        base {t('currency_symbol')} {convertDoubleToStringPTBR(item.commissionBase)}
                                                    </small>
                                                )}
                                            </td>
                                            <td>
                                                <strong>{t('currency_symbol')} {convertDoubleToStringPTBR(item.commissionValue ?? 0)}</strong>
                                                {/* Percentual nulo é ausência de regra cadastrada, que é
                                                    diferente de uma regra de 0% deliberada. */}
                                                <small className="d-block text-muted">
                                                    {item.commission != null ? `${item.commission}%` : t('gamification.commission_no_rule')}
                                                </small>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={3}><strong>{t('total')}</strong></td>
                                        <td><strong>{t('currency_symbol')} {convertDoubleToStringPTBR(totalHistory)}</strong></td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>

                        <h3 className="mt-5">{t('commission_subscription')}</h3>
                        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                            <Table responsive striped>
                                <thead>
                                    <tr>
                                        <th>{t('date_time')}</th>
                                        <th>{t('gamification.pot_product_service')}</th>
                                        <th>{t('gamification.score')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subscriptionHistory.map((item, index) => (
                                        <tr key={index}>
                                            <td>{formatDateTime(item.createdAt)}</td>
                                            <td>{item.qty} x {item.product.name}</td>
                                            <td><strong>{Math.round(item.commission)} pts</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={2}><strong>{t('total')}</strong></td>
                                        <td>
                                            <strong>
                                                {subscriptionHistory.reduce((sum, item) => sum + Math.round(item.commission) * item.qty, 0)} pts
                                            </strong>
                                        </td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>
                    </>
            }
        </div>
    )
}

export default CommissionHistory;
